<template>
  <v-row ref="generateBackup" class="pa-4" wrap>
    <v-col cols="12">
      <div v-if="info">
        {{ `${$tc('size')}: ${info.sl_be_len}` }} bytes ({{ info.sl_be_len | prettyBytes }})
      </div>
    </v-col>
    <v-col cols="12">
      <v-text-field
        id="Input_password"
        :label="$tc('password')"
        :hint="$tc('password_backup_hint')"
        type="password"
        required
        v-model="password"
        counter
        :error-messages="passwordErrors"
        @input="$v.password.$touch()"
        @blur="$v.password.$touch()"
      />
    </v-col>
    <v-col cols="12">
      <v-text-field
        id="Input_repeat_password"
        :label="$tc('repeat_password')"
        type="password"
        required
        v-model="repeatPassword"
        counter
        :error-messages="repeatPasswordErrors"
        @input="$v.repeatPassword.$touch()"
        @blur="$v.repeatPassword.$touch()"
      />
    </v-col>
    <v-col cols="12">
      <v-btn
        id="Download_btn"
        color="info"
        class="ma-0"
        :disabled="$v.$invalid"
        :dark="!$v.$invalid"
        @click="downloadBackup()"
      >
        {{ $t('generate_backup') }}
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>

import { required, sameAs, minLength } from 'vuelidate/lib/validators'

export default {
  data: function () {
    return {
      info: this.$store.state.hsm.statInfo,
      password: '',
      repeatPassword: ''
    }
  },
  validations () {
    return {
      password: {
        required,
        minLength: minLength(8)
      },
      repeatPassword: {
        required,
        sameAs: sameAs('password')
      }
    }
  },
  computed: {
    passwordErrors () {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.minLength &&
        errors.push(this.$t('$validation.min_length', { num: 8 }))
      !this.$v.password.required && errors.push(this.$t('$validation.required'))
      return errors
    },
    repeatPasswordErrors () {
      const errors = []
      if (!this.$v.repeatPassword.$dirty) return errors
      !this.$v.repeatPassword.sameAs &&
        errors.push(this.$t('$validation.same_as'))
      !this.$v.repeatPassword.required &&
        errors.push(this.$t('$validation.required'))
      return errors
    }
  },
  methods: {
    refresh () {
      this.$store.dispatch('hsm/getInfo')
    },
    downloadBackup () {
      this.$store
        .dispatch('hsm/getBackupSubmit', { pin: this.password })
        .then(res => {
          const self = this
          this.$refs.generateBackup.addEventListener('load', evt => {
            let y = evt.target.contentWindow || evt.target.contentDocument
            if (y.document) y = y.document
            if (y.body) {
              const err = JSON.parse(y.body.childNodes[0].childNodes[0].nodeValue)
              const errObj = this.$store.getters['error/getErrorObj'](err)
              if (errObj) {
                this.$notify.hsmError(errObj, err)
              } else {
                this.$notify.error({ message: err })
              }
            }
          })
          res.submit()
          this.$notify.success({})
          self.clearForm()
        })
        .catch(err => {
          this.clearForm()
          const errObj = this.$store.getters['error/getErrorObj'](err)
          if (errObj) {
            this.$notify.hsmError(errObj, err)
          } else {
            this.$notify.error({ message: err })
          }
        })
    },
    clearForm () {
      this.password = null
      this.repeatPassword = null
      this.$v.$reset()
    }
  },
  created () {
    this.refresh()
  }
}
</script>
